
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'

export default defineComponent({
  components: {},
  data() {
    return {
      userId: '',
      hashKey: '',
      authorizationId: '',
      authorization: {} as any,
      loading: false
    }
  },
  computed: {
    entityType(): string {
      let type = ''
      if (this.authorization?.building) {
        type = this.authorization.building.type
      } else {
        type = this.authorization.group_entity.type
      }
      switch (type) {
        case 'PROGRAM':
          return 'Projet Immobilier'
        case 'PROJECT':
          return 'Projet'
        case 'FLOOR':
          return 'Etage'
        case 'ILOT':
          return 'Ilôt'
        case 'BLOC':
          return 'Bloc'
        default:
          return ''
      }
    }
  },
  async beforeMount() {
    this.userId = this.$route.params.user_id as string
    this.hashKey = this.$route.params.hash_key as string
    this.authorizationId = this.$route.params.authorization_id as string
    this.loading = true
    const result = await hemisphereService.activateAuthorization(this.userId, this.hashKey, this.authorizationId)
    if (result) {
      this.authorization = result
    }
    this.loading = false
  }
})
